import { render } from "./LocalePicker.vue?vue&type=template&id=5695c654"
import script from "./LocalePicker.vue?vue&type=script&lang=js"
export * from "./LocalePicker.vue?vue&type=script&lang=js"

import "./LocalePicker.vue?vue&type=style&index=0&id=5695c654&lang=scss"
script.render = render

export default script